import React, { useCallback, useEffect, useMemo } from 'react';
import { createStyles, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, makeStyles, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { duration as MUITransitionDuration } from '@material-ui/core/styles/transitions';
import LoadingOverlay from '../LoadingOverlay';
const useStyles = makeStyles((theme) => createStyles({
    card: ({ narrow, width }) => ({
        padding: `${theme.spacing(2)}px ${theme.spacing(2)}px`,
        width: '100%',
        maxWidth: narrow ? 350 : width,
        minHeight: 100,
        color: theme.palette.text.color
    }),
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500]
    },
    text: {
        color: theme.palette.text.color
    },
    title: {
        color: theme.palette.text.color,
        padding: `0 ${theme.spacing(1)}px ${theme.spacing(2)}px`
    },
    contentContainer: {
        color: theme.palette.text.color,
        padding: `0 ${theme.spacing(1)}px`,
        position: 'relative',
        ...theme.themedClasses.scrollbar
    },
    underOverlay: {
        opacity: 0.5,
        pointerEvents: 'none'
    },
    noContentOverflow: {
        overflow: 'hidden'
    },
    actions: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: `${theme.spacing(2)}px ${theme.spacing(1)}px 0`,
        gap: 8,
        '& > *': {
            marginLeft: '0 !important'
        }
    }
}));
function CaDialog({ title, open, onClose, onCloseAnimationComplete, onOpen, showLoadingOverlay, noBodyOverflow, persistent, narrow, buttons, children, width = 560, ...otherProps }) {
    const classes = useStyles({ narrow, width });
    useEffect(() => {
        if (open && onOpen) {
            onOpen();
        }
        if (!open && onCloseAnimationComplete) {
            setTimeout(() => onCloseAnimationComplete(), MUITransitionDuration.standard);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);
    const handleCloseRequest = useCallback(() => {
        if (persistent)
            return;
        onClose();
    }, [onClose, persistent]);
    const bodyClasses = useMemo(() => [
        showLoadingOverlay ? classes.underOverlay : '',
        noBodyOverflow ? classes.noContentOverflow : ''
    ].join(' '), [classes, noBodyOverflow, showLoadingOverlay]);
    return (React.createElement(Dialog, { open: open, onClose: handleCloseRequest, PaperProps: { className: classes.card }, ...otherProps },
        React.createElement(DialogTitle, { className: classes.title },
            React.createElement(Typography, { component: "span", variant: "h6", className: classes.text }, title),
            !persistent && React.createElement(IconButton, { className: classes.closeButton, onClick: onClose },
                React.createElement(CloseIcon, null))),
        React.createElement(DialogContent, { className: classes.contentContainer },
            showLoadingOverlay && React.createElement(LoadingOverlay, { ml: -1 }),
            React.createElement("div", { className: bodyClasses }, children)),
        buttons && (React.createElement(DialogActions, { className: classes.actions }, ...buttons))));
}
export default CaDialog;
